import ChartBarService from './ChartBarService';
import ChartHorizontalBarService from './ChartHorizontalBarService';
import ChartGroupBarService from './ChartGroupBarService';
import ChartHorizontalGroupBarService from './ChartHorizontalGroupBarService';
import ChartDonutService from './ChartDonutService';
import ChartGeoHeatMapService from './ChartGeoHeatMapService';
import ChartLineService from './ChartLineService';
import ChartSankeyService from './ChartSankeyService';
import ChartScatterService from './ChartScatterService';
import ChartLineAreaService from './ChartLineAreaService';
import ChartKaplanMeierService from './ChartKaplanMeierService';
import ChartDefaultService from './ChartDefaultService';

export default class ChartServiceFactory {
  static create(visualizationType) {
    switch (visualizationType) {
      case 'barchart':
        return new ChartBarService();
      case 'horizontalbarchart':
        return new ChartHorizontalBarService();
      case 'groupbarchart':
        return new ChartGroupBarService();
      case 'horizontalgroupbarchart':
        return new ChartHorizontalGroupBarService();
      case 'donutchart':
        return new ChartDonutService();
      case 'geoheatmap':
        return new ChartGeoHeatMapService();
      case 'linechart':
        return new ChartLineService();
      case 'sankey':
        return new ChartSankeyService();
      case 'scatterchart':
        return new ChartScatterService();
      case 'lineareachart':
        return new ChartLineAreaService();
      case 'kaplanmeierchart':
        return new ChartKaplanMeierService();
      default:
        return new ChartDefaultService();
    }
  }
}
